<template>
  <PageHeader title="Manage users" subtitle="Manage users" />

  <TableLayout>
    <UsersTable :users="users" />
  </TableLayout>
</template>

<script setup>
import { onMounted } from "vue";

import { useUsers } from "@/composables/useUsers";
import TableLayout from "@/layouts/TableLayout.vue";
import UsersTable from "@/views/ManageUsersView/components/UsersTable.vue";
import PageHeader from "@/components/PageHeader.vue";

const { users, fetchUsers } = useUsers();

onMounted(fetchUsers);
</script>
